import emptySplitApi from "../utils/rtk";
import { END_POINTS } from "../helpers";

export const productApi = emptySplitApi.injectEndpoints({
  endpoints: (builder) => ({
    addProduct: builder.mutation({
      query: (body) => ({
        url: END_POINTS.addProduct,
        method: "POST",
        body,
      }),
    }),

    getCategory: builder.query({
      query: ({}) => ({
        url: END_POINTS.getCategory,
        method: "GET",
      }),
    }),

    getSubCategory: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.getSubCategory}${id}/`,
        method: "GET",
      }),
    }),

    getAllProducts: builder.mutation({
      query: (body) => ({
        url: END_POINTS.getAllProducts,
        method: "POST",
        body,
      }),
    }),

    getProductById: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.getProductById}${id}/`,
        method: "GET",
      }),
    }),

    updateProduct: builder.mutation({
      query: ({ body, id }) => ({
        url: `${END_POINTS.updateProduct}${id}/`,
        method: "PUT",
        body,
      }),
    }),

    deleteProduct: builder.mutation({
      query: (id) => ({
        url: `${END_POINTS.deleteProduct}${id}/`,
        method: "DELETE",
      }),
    }),

    getProductViews: builder.query({
      query: ({ id }) => ({
        url: `${END_POINTS.productViews}${id}/`,
        method: "GET",
      }),
    }),
  }),
});

export const {
  useAddProductMutation,
  useLazyGetCategoryQuery,
  useLazyGetSubCategoryQuery,
  useGetAllProductsMutation,
  useLazyGetProductByIdQuery,
  useUpdateProductMutation,
  useDeleteProductMutation,
  useLazyGetProductViewsQuery,
} = productApi;
